<template>
    <div class="searchAccessory" >
        <div class="accessory-item" v-for="(item,index) in washProductAccessoryList" :key="index" @click="onAccessory(item)">
            {{ item.accessoryName }}
        </div>
    </div>
</template>

<script>
import { get, postJson, post } from '@/utils/request.js';

export default {
    data(){
        return{
            washProductAccessoryList: [],
        }
    },
    mounted() {
        this.getWashProductAccessoryList();
    },
    methods:{
        getWashProductAccessoryList(){
            get("/wash/utils/findAllWashProductAccessory").then((res)=>{
                if(res.success){
                    this.washProductAccessoryList = res.list
                }
            })
        },

        onAccessory(accessoryItem){
            this.$emit("onAccessory", accessoryItem)
        }
    }
}
</script>

<style scoped lang="scss">
.searchAccessory{
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .accessory-item{
        display: inline-block;
        margin:  0 0 10px 10px;
        padding: 12px 20px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        cursor: pointer;
    }

}
</style>